import { AuthContext } from '@repo-level/core-front';
import { createScript } from 'helpers/common';
import { CustomerIOEvents } from 'helpers/customerio';
import type { FC } from 'react';
import { createContext, useContext, useEffect } from 'react';
import { NotificationProvider, notificationsMap } from './3rdParty';

export const NotificationsContext = createContext<{}>(null as any);

export const NotificationsContextProvider: FC = ({ children }) => {
  const { user } = useContext(AuthContext);

  const { path, identifyUser, resetUser, trackEvent } =
    window.appConfig.APP_ENV === 'development'
      ? notificationsMap[NotificationProvider.None]
      : notificationsMap[NotificationProvider.CustomerIO];

  useEffect(() => {
    if (user?.id == null) return;

    identifyUser(user.id);

    return () => {
      resetUser();
    };
  }, [user, identifyUser, resetUser]);

  useEffect(() => {
    if (!path) return;

    const script = createScript(path);

    script.onload = () => {
      const isStandalone =
        window.matchMedia('(display-mode: standalone)').matches ||
        (window.navigator as any).standalone === true;

      if (isStandalone) {
        trackEvent(CustomerIOEvents.PWA_OPENED);
      }
    };

    return () => {
      script.remove();
    };
  }, [path, trackEvent]);

  return (
    <NotificationsContext.Provider value={{}}>
      {children}
    </NotificationsContext.Provider>
  );
};
